import React from "react";
import { Typography, Box, useTheme } from "@mui/material";
import { styled, keyframes } from "@mui/system";
import { Link } from "react-router-dom";
import logoImage from "../../assets/images/logo512.png";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const AnimatedLogo = styled("div")(() => ({
  width: "20px",
  height: "20px",
  backgroundImage: `url(${logoImage})`,
  backgroundSize: "contain",
  animation: `${spin} 2s linear infinite`,
}));

const LogoComponent = () => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={2}
      component={Link}
      to="/"
      sx={{
        textDecoration: "none",
        color: "inherit",
        "&:hover": {
          color: theme.palette.primary.main,
        },
        marginLeft: 2,
      }}
    >
      <AnimatedLogo />
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          color: theme.palette.mode === "dark" ? "white" : "black",
          "&:hover": {
            color: theme.palette.primary.main,
          },
        }}
      >
        Guadalupe Rosas
      </Typography>
    </Box>
  );
};

export default LogoComponent;